import axiosInstance from '../../../../config/axiosInstance';

const ModuleService = {
    async GetAllModules(redirectCallback, lang) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const RoleID = localStorage.getItem('RoleID');
            const response = await axiosInstance.get(`/Setup/GetAllModules?ClientID=${ClientID}&RoleID=${RoleID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message === "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetCompanyModules(redirectCallback, lang, ClientID) {
        try {
            const response = await axiosInstance.get(`/Setup/GetCompanyModules?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message === "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetRoleModules(redirectCallback, lang, ClientID) {
        try {
            const RoleID = localStorage.getItem('RoleID');
            const response = await axiosInstance.get(`/Setup/GetRoleModules?ClientID=${ClientID}&RoleID=${RoleID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message === "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetAllModulesWithClient(redirectCallback, lang, ClientID) {
        try {
            const response = await axiosInstance.get(`/Setup/GetAllModulesWithClient?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message === "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetModuleByClientID(ClientID, ModuleID) {
        try {
            const response = await axiosInstance.get(`/Setup/GetModuleByClientID?ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching roles:', error);
            throw error;
        }
    }
};

export default ModuleService;